/**
 * Ordem estável para VTME / e-mail CQV em grupos mistos (Aditivo + Renegociação).
 * Aditivo primeiro evita que só o segundo e-mail seja percebido na mesma thread.
 */
export type VtmeGroupSortable = {
  id: string;
  contractType?: string | null;
  tipoContratacao?: string | null;
};

const vtmeTypeSortRank = (c: {
  contractType?: string | null;
  tipoContratacao?: string | null;
}): number => {
  const raw = String(c.contractType || c.tipoContratacao || '').toLowerCase();
  if (raw.includes('aditivo')) return 0;
  if (raw.includes('reneg')) return 2;
  return 1;
};

export function sortContractsForVtmeGroupOrder<T extends VtmeGroupSortable>(items: T[]): T[] {
  return [...items].sort((a, b) => vtmeTypeSortRank(a) - vtmeTypeSortRank(b));
}

export function getContractTypeLabel(c: {
  contractType?: string | null;
  tipoContratacao?: string | null;
}): string {
  return c.tipoContratacao || c.contractType || 'Contrato';
}

export function isAditivoContract(c: {
  contractType?: string | null;
  tipoContratacao?: string | null;
}): boolean {
  return String(c.contractType || c.tipoContratacao || '').toLowerCase().includes('aditivo');
}

export function isRenegociacaoContract(c: {
  contractType?: string | null;
  tipoContratacao?: string | null;
}): boolean {
  return String(c.contractType || c.tipoContratacao || '').toLowerCase().includes('reneg');
}

export function shouldRenderSeparatedContractGroupAsRows<T extends VtmeGroupSortable>(items: T[]): boolean {
  if (items.length < 2) return false;

  const hasAditivo = items.some(isAditivoContract);
  const hasRenegociacao = items.some(isRenegociacaoContract);
  const allAreSeparatedTypes = items.every((item) => isAditivoContract(item) || isRenegociacaoContract(item));

  return hasAditivo && hasRenegociacao && allAreSeparatedTypes;
}

export function getContractIdsForVtmeEmail<T extends VtmeGroupSortable>(
  contract: T & { isGroupParent?: boolean; groupContracts?: T[] | null }
): string[] {
  if (contract.isGroupParent && contract.groupContracts && contract.groupContracts.length > 0) {
    return sortContractsForVtmeGroupOrder(contract.groupContracts).map((c) => c.id);
  }
  return [contract.id];
}
